import React from "react";

// Decorative scattered "+" sparkle marks like the original hero background
const positions = [
  { top: "11%", left: "8%", size: 16, o: 0.5 },
  { top: "17%", left: "47%", size: 12, o: 0.35 },
  { top: "20%", left: "88%", size: 13, o: 0.4 },
  { top: "33%", left: "79%", size: 22, o: 0.7 },
  { top: "50%", left: "6%", size: 14, o: 0.45 },
  { top: "63%", left: "93%", size: 14, o: 0.4 },
  { top: "78%", left: "22%", size: 16, o: 0.4 },
];

export default function Sparkles() {
  return (
    <div className="pointer-events-none absolute inset-0 overflow-hidden" aria-hidden="true">
      {positions.map((p, i) => (
        <span
          key={i}
          className="absolute select-none font-light text-violet-300"
          style={{
            top: p.top,
            left: p.left,
            fontSize: `${p.size}px`,
            opacity: p.o,
            animation: `twinkle ${3 + (i % 3)}s ease-in-out ${i * 0.4}s infinite`,
          }}
        >
          +
        </span>
      ))}
      <style>{`@keyframes twinkle {0%,100%{opacity:.2;transform:scale(.9)}50%{opacity:.7;transform:scale(1.15)}}`}</style>
    </div>
  );
}
